import React from 'react';
import { useTheme, ThemeMode } from '../hooks/useTheme';

const CYCLE: ThemeMode[] = ['light', 'dark'];
const LABEL: Record<ThemeMode, string> = { light: '☀️', dark: '🌙', auto: '⚙️' };

const DevThemeToggle: React.FC = () => {
  const { mode, setMode } = useTheme();

  const next = () => {
    const idx = CYCLE.indexOf(mode);
    setMode(CYCLE[(idx + 1) % CYCLE.length]);
  };

  return (
    <button
      onClick={next}
      title={`Theme: ${mode} — click to cycle`}
      style={{
        position: 'fixed',
        bottom: '8px',
        right: '8px',
        zIndex: 99999,
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        fontSize: '12px',
        lineHeight: 1,
        padding: 0,
        opacity: 0.7,
      }}
    >
      {LABEL[mode]}
    </button>
  );
};

export default DevThemeToggle;
